import limeBikeImage from "../assets/images/optimized/limeBike.png";

export const firstRewardConfig = {
  id: "first-reward",
  name: "Lime Bike | 25% off",
  hint: "Your first reward awaits! Complete registration to unlock exclusive Lime Bike discounts.",
  offer:
    "Celebrate the TCS Sydney Marathon with Lime. Get 25% off using code SYDMARA25 on your ride!",
  address: "Available across Sydney",
  hours: "24/7",
  redeem: "Use code SYDMARA25 in the Lime app",
  terms: "Valid for up to three (3) uses during event week",
  code: "SYDMARA25",
  coordinates: {
    latitude: -33.8688,
    longitude: 151.2093,
  },
  image: limeBikeImage,
};
